class HeroAnimation {
  constructor() {
    // Select only hero image container elements
     this.heroes = document.querySelectorAll('.lc-image__image-container__hero, .lc-video__video-container__hero');
    if (this.heroes.length > 0) {
      this.animatedHeroes = new Set();
      this.init();
    }
  }

  init() {
    // Set initial styles for hero elements
    this.heroes.forEach(hero => {
      hero.style.opacity = '0';
      hero.style.transition = 'opacity 0.5s ease-out';
    });

    // Bind and attach scroll/resize events
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onScroll);
    this.onScroll();
  }

  onScroll() {
    this.heroes.forEach(hero => {
      if (!this.animatedHeroes.has(hero) && this.isElementAlmostInViewport(hero)) {
        hero.classList.add('animate');
        hero.style.opacity = '1';
        this.animatedHeroes.add(hero);
      }
    });

    if (this.animatedHeroes.size === this.heroes.length) {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
  }

  isElementAlmostInViewport(el) {
    const rect = el.getBoundingClientRect();
    const buffer = window.innerHeight * 0.3;
    return rect.top < window.innerHeight - buffer && rect.bottom >= 0;
  }
}

export default HeroAnimation;
